const data = [
  {
    "id": "updated",
    "label": "",
    "value": 0,
    "color": "#41a017"
  },

  {
    "id": "notUpdated",
    "label": "",
    "value": 0,
    "color": "#eeeef0"
  },

  {
    "id": "empty",
    "label": "",
    "value": 100,
    "color": "#eeeef0"
  }
]


export default data
